export default "__VITE_ASSET__CZ6AZ1xn__$_?url__"